import React from 'react';
import * as $ from 'jquery';
import useHttp from '../../../../../hook/use-http';
import { useState, useRef, useEffect } from 'react';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { INIT_STATE_SELECTS, INDEX } from "../../../../../constants/driveglobalfilterinitalstates_bus";
import Customselectgrowth from './Customselectgrowth';
import { BsFillSkipBackwardBtnFill } from "react-icons/bs";
import { API_URL_MAIN } from '../../../../../constants/driveglobalfilterinitalstates_bus';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCityDepo } from '../../../../../redux/cityDepoSlice';

// import "./BDT_Filter_Bus.css"
// import { FaBackward } from 'react-icons/fa';
// import styles from './BDT_Bus.module.css'
// import styles from './Filter_Bus.module.css'
// import filterStyles from './BDT_Filter_Bus.module.css'
// import "./BDT_Filter_Bus.css"
// import "./styles.css"
 
 
export default function Filter_growth(props) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [filterdata, setFilterData] = useState({ ...props.gloablfilter });
  // const [changedColumn, setChangedColumn] = useState("");
  // const [columnfilters, setcolumnfilters] = useState([]);
  // const [routeOptions, setRouteOptions] = useState([]);
  // const [selectedRoute, setSelectedRoute] = useState([]);
  // const [selectedDepo, setSelectedDepo] = useState([]);
  // // const [singleBtn, setsingleBtn] = useState(false);
  // const [lastChangedField, setLastChangedField] = useState("");
const { setGloablfilter } = props
 
  // useEffect(() => {
  //   // Reset depo and route when city changes
  //   if (filterdata.CITY) {
  //     setSelectedDepo([]);
  //     setSelectedRoute([]);
  //     setFilterData(prev => ({ ...prev, DEPO: [], ROUTE: [] }));
  //     props.onsubmit(prev => ({ ...prev, DEPO: [], ROUTE: [] }));
  //   }
  // }, [filterdata.CITY]);

  // useEffect(() => {
  //   // Reset route when depo changes
  //   if (filterdata.DEPO) {
  //     setSelectedRoute([]);
  //     setFilterData(prev => ({ ...prev, ROUTE: [] }));
  //     props.onsubmit(prev => ({ ...prev, ROUTE: [] }));
  //   }
  // }, [filterdata.DEPO]);
 
 
  const inputRef = useRef(null);
 
  // const updateFilter = (arr, index) => {
  //   console.log(arr,index)
  //   let state_ind = INDEX[index];
  //   setFilterData((prev) => { return { ...filterdata, [state_ind]: arr } })
  //   props.onsubmit((prev) => { return { ...filterdata, [state_ind]: arr } });
 
  //   setChangedColumn(index);
  //   if (columnfilters.indexOf(index) == -1) {
  //     setcolumnfilters([...columnfilters, index]);
  //   }
  // }
 
 
  // const formatDateForDisplay = (date) => {
  //   return date ? moment(date).format('MMM D, YYYY') : '';
  
 
  // useEffect(() => {
  //   if (filterdata.startDate) {
  //     const today = moment();
  //     const fiveYearsAgo = moment().subtract(5, 'years');
  //     const defaultStart = moment(filterdata.startDate);
  //     const defaultEnd = moment(filterdata.endDate);
 
  //     $(inputRef.current).daterangepicker(
  //       {
  //         startDate: defaultStart,
  //         endDate: defaultEnd,
  //         minDate: fiveYearsAgo,
  //         maxDate: today,
  //         showDropdowns: true,
  //         autoUpdateInput: false, // Disable auto input update
  //         singleMonthMode: true,
  //         linkedCalendars: false,
  //         locale: {
  //           format: 'MMMM D, YYYY',
  //           applyLabel: 'Apply',
  //           separator: ' - ',
  //           cancelLabel: '',
  //         },
  //       }
  //     );
 
  //     // Handle 'Apply' button click
  //     $(inputRef.current).on('apply.daterangepicker', function (ev, picker) {
  //       const start = picker.startDate.format("YYYY-MM-DD");
  //       const end = picker.endDate.format("YYYY-MM-DD");
 
  //       $(this).val(
  //         picker.startDate.format('MMMM D, YYYY') + ' - ' + picker.endDate.format('MMMM D, YYYY')
  //       );
 
  //       setFilterData(prev => ({
  //         ...prev,
  //         startDate: start,
  //         endDate: end,
  //       }));
  //       props.onsubmit(prev => ({
  //         ...prev,
  //         startDate: start,
  //         endDate: end,
  //       }));
  //     });
 
  //     // Optional: clear input on cancel
  //     $(inputRef.current).on('cancel.daterangepicker', function () {
  //       $(this).val('');
  //       setFilterData(prev => ({
  //         ...prev,
  //         startDate: null,
  //         endDate: null,
  //       }));
  //     });
  //   }
 
  //   return () => {
  //     if ($(inputRef.current).data('daterangepicker')) {
  //       $(inputRef.current).data('daterangepicker').remove();
  //       $(inputRef.current).off('.daterangepicker');
  //     }
  //   };
  // }, []);
 
  return (
    <>
    <div className="container-fluid px-4">
      <div className="card mb-4 p-3">
        <div className="row">
 
          {/* Wider Date Range */}
          {/* <div className="col-md-3">
            <div className={`mb-1 ${styles.date_range_selection}`}>Date Range</div>
            <div className="input-group mt-1">
              <input
                type="text"
                ref={inputRef}
                className={`form-control ${styles.customDateRangePicker}`}
                placeholder="Select date range"
                value={
                  filterdata.startDate && filterdata.endDate
                    ? `${formatDateForDisplay(filterdata.startDate)} - ${formatDateForDisplay(filterdata.endDate)}`
                    : ''
                }
                readOnly
              />
            </div>
          </div> */}
 
          {/* Other inputs */}
          <div className="col-md-9">
            <Customselectgrowth setGlobalFilter={props.setGlobalFilter} ></Customselectgrowth>
          </div>
          

        
        </div>
      </div>
      </div>
    </>
  )

 
 
}
 
 
 
 
 
 
